import { BuildGradientStyle } from '@utils/buildGradientStyle'
import { ReactNode } from 'react'

interface ModalHeaderProps {
    children: ReactNode
    gradientStyle?: BuildGradientStyle
}

export const BonusModalHeader = ({ children, gradientStyle }: ModalHeaderProps) => {
    return (
        <div
            id="bonus-modal-header"
            style={gradientStyle}
            className="bg-gradient-to-r text-center h-[88px] flex items-center justify-center"
        >
            {children}
        </div>
    )
}
